import { render, staticRenderFns } from "./WeighScale.vue?vue&type=template&id=0352f811&scoped=true&"
import script from "./WeighScale.vue?vue&type=script&lang=js&"
export * from "./WeighScale.vue?vue&type=script&lang=js&"
import style0 from "./WeighScale.vue?vue&type=style&index=0&id=0352f811&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0352f811",
  null
  
)

export default component.exports